import React from 'react';
import './GameEndScreen.css';

const GameEndScreen = ({ score, questions, returnHome }) => {
  const isHighScore = score >= 4;
  
  return (
    <div className="screen game-end-screen">
      <div className="game-background">
        {/* Confetti overlay for high scores */}
        {isHighScore && (
          <div className="confetti-overlay">
            <img 
              src="/images/win_tape.png" 
              alt="Congratulations!" 
              className="confetti-image"
            />
          </div>
        )}
        
        <div className="home-container">
          <div className="title-section">
            <img 
              src="/images/title.png" 
              alt="EDB Landt Quiz" 
              className="game-title-image"
            />
          </div>
          
          <div className="intro-frame">
            <div className="game-intro-content">
              <div className="game-description">
                <div className="game-subtitle">
                  { isHighScore && '做得好！' }你答對了 <span className='score-number'>{score}</span> 道題目。 關於購買教科書的問題，請前往旁邊的資訊站，瀏覽更多相關資訊吧！<br/><br/>
                  { isHighScore && 'Well done! ' }You answered <span className='score-number'>{score}</span> questions correctly. For any questions regarding textbook purchases, please visit the information kiosk nearby to access additional details!
                </div>
              </div>
            </div>
          </div>

          <div className="start-button-container">
            <button className="start-game-btn" onClick={returnHome}>
              回主頁<br/>Return to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameEndScreen; 